import { Component, OnInit, Input, ViewChild, TemplateRef, ComponentFactoryResolver, Injector, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { workFlowActions, executionTime, FormMethodConfig } from '../entities/form-method-config';
import { HttpService } from '@ecp-caf/caf-common';
import { FormMethod } from '../entities/form-method';
import { DialogComponent } from '@farris/ui-dialog';
import { DatagridComponent } from '@farris/ui-datagrid';
import { MessagerService } from '@farris/ui-messager';
import { BsModalService } from '@farris/ui-modal';
import { ParameterSettingComponent } from '../parameter-setting/parameter-setting.component';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-form-operation-config',
  templateUrl: './form-operation-config.component.html',
  styleUrls: ['./form-operation-config.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class FormOperationConfigComponent implements OnInit {
  private _fromFormatId: string;
  @Input()
  set formFormatId(v: string) {
    this._fromFormatId = v;
    if (this._fromFormatId) {
      this.getFormMethods();
    }
  }
  get formFormatId() {
    return this._fromFormatId;
  }

  @Input() formFormatConfigId: string;
  @Input() operations = new Array<FormMethodConfig>();
  @Input() hasRequired = true;

  @ViewChild('methodsDialog') methodsDialog: DialogComponent;
  @ViewChild('grid') grid: DatagridComponent;
  @ViewChild('methodGrid') methodGrid: DatagridComponent;
  @ViewChild('cell') cell: TemplateRef<any>;

  cols = new Array();

  methodCols = [
    { field: 'method', width: 100, title: this.localePipe.transform("component.executeForms.method"), showTips: true },
    { field: 'methodName', width: 80, title: this.localePipe.transform("component.executeForms.methodName"), showTips: true },
    { field: 'description', width: 120, title: this.localePipe.transform("component.executeForms.description"), showTips: true }
  ];
  e: any;

  formMethods = new Array<FormMethod>();
  state: 'add' | 'edit' = 'add';
  groupText = '<i class="f-icon f-icon-lookup"></i>';
  //如果是编辑，记录第几行数据的id,因为编辑后修改参数的时候行数据没有更新过来
  rowId

  constructor(
    private http: HttpService,
    private message: MessagerService,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private modalService: BsModalService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) { }

  ngOnInit() {
    this.cols = [
    {
      field: 'workFlowAction', width: 80, title: this.localePipe.transform("component.executeForms.workFlowAction"),
      formatter: {
        type: 'enum',
        options: { valueField: 'value', textField: 'text', data: workFlowActions }
      },
      editor: {
        type: EditorTypes.COMBOLIST,
        options: { valueField: 'value', textField: 'text', data: workFlowActions, idField: 'value', panelHeight: 'auto', enableClear: false }
      },
      validators: [
        { type: 'required', messager: '必填' }
      ]
    }, {
      field: 'method', width: 100, title: this.localePipe.transform("component.executeForms.formOperations"),
      readonly:(rowData) => {
        if(this.hasRequired && rowData && rowData.method === 'wf-required-verification') {
          return true;
        }
        return false;
      },
      editor: {
        type: 'input-group',
        options: {
          groupText: '<i class="f-icon f-icon-lookup"></i>',
          editable: false,
          clickHandle: (e) => {
            e.formControl.setValue(e.instance.value ? e.instance.value : '');
            this.e = e;
            this.methodsDialog.show();
            this.rowId = e.rowId;
            this.state = 'edit';
          },
          clear: (e) => {
            console.log('clear', e);
          }
        }
      },
      formatter: (v, d, i) => {
        if (v) {
          const m = this.formMethods.find(item => item.method === v);
          if (m) {
            return m.methodName;
          } else {
            return '';
          }
        } else {
          return '';
        }
      },
      validators: [
        { type: 'required', messager: '必填' }
      ]
    },
    {
      field: 'executionTime', width: 80, title: this.localePipe.transform("component.executeForms.executionTime"),
      readonly:(rowData) => {
        if(this.hasRequired && rowData && rowData.method === 'wf-required-verification') {
          return true;
        }
        return false;
      },
      formatter: {
        type: 'enum',
        options: { valueField: 'value', textField: 'text', data: executionTime }
      },
      editor: {
        type: EditorTypes.COMBOLIST,
        options: { valueField: 'value', textField: 'text', data: executionTime, idField: 'value', panelHeight: 'auto', enableClear: false }
      },
      validators: [
        { type: 'required', messager: '必填' }
      ]
    },
    {
      field: 'sortOrder', width: 60, title: this.localePipe.transform("component.executeForms.sortOrder"),
      editor: {
        type: EditorTypes.NUMBERBOX, options: {
        }
      },
      formatter: { type: 'number', options: { precision: 0 } },
      validators: [
        { type: 'required', messager: '必填' }
      ]
    },
    {
      field: 'methodParameters', width: 80, title: this.localePipe.transform("component.executeForms.methodParameters"),
      template: this.cell,
      halign: 'center', align: 'center'
    }
  ];
  }

  add() {
    this.methodsDialog.show();
    this.state = 'add';
  }

  delete() {
    if (this.grid.selectedRow) {
      if(this.grid.selectedRow.data && this.grid.selectedRow.data.method === 'wf-required-verification' && this.hasRequired) {
        this.message.info(this.localePipe.transform("component.executeForms.operationDelete"));
        return;
      }
      this.operations = this.operations.filter(o => o.id !== this.grid.selectedRow.id);
      this.grid.loadData(this.operations);
      this.grid.clearAll();
    } else {
      this.message.info(this.localePipe.transform("component.executeForms.selectFormActionConfig"));
    }
  }

  editParam(ctx: any) {
    const compFactory = this.resolver.resolveComponentFactory(ParameterSettingComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.mode = 'usual';
    compRef.instance.showFormType = false;
    if (ctx.rowData.methodParameters) {
      compRef.instance.parameters = [...ctx.rowData.methodParameters.map(p => Object.assign({}, p))];
    } else {
      compRef.instance.parameters = new Array();
    }

    const modalConfig = {
      title: this.localePipe.transform("component.executeForms.parameterSettings"),
      width: 620,
      height: 400,
      showButtons: true,
      buttons: compRef.instance.modalFooter
    };
    const dialog = this.modalService.show(compRef, modalConfig);

    compRef.instance.submit.subscribe(re => {
      for (const o of this.operations) {
        if (o.id === ctx.rowData.id) {
          o.methodParameters = re.parameters;
        }
      }
      dialog.close();
    });
    compRef.instance.cancel.subscribe(re => {
      dialog.close();
    });
  }

  methodSelected() {
    if (this.methodGrid.selectedRow) {
      const data = this.methodGrid.selectedRow.data;
      if('wf-required-verification' === data.method && (!this.hasRequired || (this.operations && this.operations.some(operation => operation.method === 'wf-required-verification')))) {
        this.message.info(this.localePipe.transform("component.executeForms.operationAdd"));
        return;
      }
      if(this.operations && this.operations.some(operation => operation.method === data.method)) {
        this.message.info(this.localePipe.transform("component.executeForms.canAddSameOperation"));
        return;
      }
      if (this.state === 'edit') {
        if (this.e) {
          this.e.formControl.setValue(data.method);
          this.e.instance.cd.detectChanges();
          for (const o of this.operations) {
            if (o.id === this.rowId) {
              o.method = data.method;
              o.sortOrder = data.sortOrder;
              o.methodParameters = data.methodParameters;
            }
          }
        }
        this.rowId = null;
      } else {
        const operation = new FormMethodConfig();
        operation.formFormatConfigId = this.formFormatConfigId;
        operation.method = data.method;
        operation.sortOrder = data.sortOrder;
        operation.methodParameters = data.methodParameters;
        this.operations = this.operations.concat([operation]);
      }
      this.methodsDialog.close();
    } else {
      this.message.info(this.localePipe.transform("component.executeForms.selectFormAction"));
    }
  }

  validator(): boolean {
    this.grid.endCellEdit();
    for (const o of this.operations) {
      if (!o.method) {
        this.message.info(this.localePipe.transform("component.executeForms.selectFormAction"));
        return false;
      }
    }
    return true;
  }

  private getFormMethods() {
    if (this.formFormatId) {
      const url = `/api/runtime/wf/v1.0/formOperation?formFormatId=${this.formFormatId}`;
      this.http.get(url).subscribe((re: any) => {
        if (re) {
          this.formMethods = re;
        }
      });
    }
  }

}
